import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 17h18v2H3v-2zm0-7h18v5H3v-5zm0-4h18v2H3V6z"
}), 'CalendarViewDaySharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CalendarViewDaySharp.js
// module id = 2586
// module chunks = 2